import { Text } from '@chakra-ui/react'
import { mdiClose } from '@mdi/js'
import Icon from '@mdi/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Flex } from '@/components/ui/flex'
import useColorModeValue from '@/hooks/useColorModeValue'
import useCustomMediaQuery from '@/hooks/useCustomMediaQuery'

const TextExamples = ({
    options,
    onNewQuestion,
    isClickable,
}: {
    options: Array<string> | undefined
    isClickable: boolean
    onNewQuestion: (question: string) => void
}) => {
    const { t } = useTranslation()
    const [isOpen, setIsOpen] = useState<boolean>(true)
    const [isMobile] = useCustomMediaQuery()
    const textHeaderColor = useColorModeValue('rgba(84, 79, 64, 0.7)', 'rgba(255, 255, 255, 0.7)')
    const textColor = useColorModeValue('var(--chakra-colors-dark-700)', 'var(--chakra-colors-white)')

    if (!isOpen || !options) {
        return
    }

    const onCloseClick = () => {
        setIsOpen(false)
    }

    const onNewQuestionClick = (question: string) => {
        setIsOpen(false)
        onNewQuestion(question)
    }

    return (
        <Box mt="16px" data-testid="chat-examples">
            <Flex maxW={isMobile ? '100%' : 'max-content'} flexDirection="column">
                <Flex mb="8px" justifyContent="space-between">
                    <Text
                        data-testid="chat-examples-title"
                        color={textHeaderColor}
                        fontSize="14px"
                        textTransform="uppercase"
                        letterSpacing="1px"
                    >
                        {t('chat.textExamples.title')}
                    </Text>
                    <Box onClick={onCloseClick} data-testid="chat-examples-close-button" cursor="pointer">
                        <Icon path={mdiClose} size="13px" style={{ marginTop: '2px' }} />
                    </Box>
                </Flex>
                {options.map((item) => {
                    return (
                        <Box
                            borderRadius="4px"
                            border="1px dashed rgb(216, 215, 213)"
                            w="fit-content"
                            pl="8px"
                            pr="8px"
                            pt="2px"
                            mb="4px"
                            color={textColor}
                            fontSize="14px"
                            letterSpacing="0.25px"
                            key={item}
                            onClick={isClickable ? () => onNewQuestionClick(item) : undefined}
                            cursor={isClickable ? 'pointer' : 'default'}
                            data-testid="chat-example-item"
                        >
                            {item}
                        </Box>
                    )
                })}
            </Flex>
        </Box>
    )
}

export default TextExamples
